import EssenceIcon from './essence-icon'

export default function MobileSwitcher({ mobileOpen, onOpen, onIntent }) {
  return <button type="button" aria-label="Open mobile menu" aria-expanded={mobileOpen}
    aria-controls="site-mobile-navigation" onClick={onOpen} onPointerEnter={onIntent} onFocus={onIntent} onTouchStart={onIntent} className="block py-2 xl:hidden">
    <EssenceIcon name="menu" className="size-5 md:size-6 md:[stroke-width:1.875]" />
  </button>
}
